import favoriteGetAllLocal from "../../localStore/favorite/getAll";


const favoriteGetAllRequest = async () => await favoriteGetAllLocal();
export default favoriteGetAllRequest;